import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_TYPES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";

const AlternateAction = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const link = useMemo(() => {
    if (location.pathname === "/login") {
      return {
        title: t("layouts.labels.applyToJoinQuestion"),
        to: "/apply",
        buttonContent: t("layouts.labels.applyToJoin"),
      };
    }

    if (location.pathname.startsWith("/reset-password")) {
      return {
        title: t("layouts.labels.rememberedYourPassword"),
        to: "/login",
        buttonContent: t("layouts.labels.signIn"),
      };
    }

    return {
      title: t("layouts.labels.haveAnAccount"),
      to: "/login",
      buttonContent: t("layouts.labels.signIn"),
    };
  }, [location.pathname, t]);

  return (
    <div className="flex items-center justify-center gap-100">
      <span className="body-s-regular onboarding-alternate-action__text">
        {link.title}
      </span>

      <BaseButton
        to={link.to}
        type={BUTTON_TYPES.LINK}
        variant={BUTTON_VARIANTS.LINK}
      >
        {link.buttonContent}
      </BaseButton>
    </div>
  );
};

export default AlternateAction;
